import { render, staticRenderFns } from "./ServiceableEditor.vue?vue&type=template&id=56aeeaec"
import script from "./ServiceableEditor.vue?vue&type=script&lang=js"
export * from "./ServiceableEditor.vue?vue&type=script&lang=js"
import style0 from "./ServiceableEditor.vue?vue&type=style&index=0&id=56aeeaec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports